import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import * as serviceAPI  from './services/API.service';
import * as serviceMain  from './services/main.service';

const app = createApp(App)
app.use(store)
app.use(i18n)
app.use(router)
app.use(VueSweetalert2)
app.config.globalProperties.$call_api = serviceAPI.call_API;
app.config.globalProperties.$showErrorAlert = serviceMain.showErrorAlert;
app.mount('#app')